import { render, staticRenderFns } from "./Voucher_Summary_Voucher.vue?vue&type=template&id=5159d6c2&scoped=true&"
import script from "./Voucher_Summary_Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher_Summary_Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher_Summary_Voucher.vue?vue&type=style&index=0&id=5159d6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159d6c2",
  null
  
)

export default component.exports